import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable} from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { Plan } from '../model/response/plan-response';
import { LoginResponse } from '../model/response/auth-response';
import { TokenPackage } from '../model/response/token-package.model';

@Injectable({providedIn: 'root'})
export class GlobalService {
  fileUrl: string;

  constructor(private http: HttpClient) {
    this.fileUrl = enviroment.BASE_URL_API + '/global';
  }

  FindUseEmail(email:string): Observable<any> {
    const url = `${this.fileUrl}/email/${email}`;
    return this.http.get<any>(url);
  }

  getPlans(currency?: string): Observable<Plan[]> {
    let params = new HttpParams();
    if (currency) params = params.set('currency', currency);
    return this.http.get<Plan[]>(`${this.fileUrl}/plans`, { params });
  }

  getTokenPackages(currency?: string): Observable<TokenPackage[]> {
    let params = new HttpParams();
    if (currency) params = params.set('currency', currency);
    return this.http.get<TokenPackage[]>(`${this.fileUrl}/token-packages`, { params });
  }

  getGeoIp(): Observable<{ country_code: string }> {
    return this.http.get<{ country_code: string }>(`${this.fileUrl}/geoip`);
  }

  oauthCallback(code: string, redirectUri: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.fileUrl}/oauth/callback`, { code, redirectUri });
  }

}
